import { FC, useRef } from 'react';
import { Content } from '../styles';
import PageCKEditor from '../../FileManager/ItemsViewer/Quill/PageCkEditor';
import styled from 'styled-components';
import { boxShadow1 } from 'utils/style/colors';

const Caption = styled.div`
  min-height: 3rem;
  padding: 1rem 0;
  font-size: 1.25rem;
`;

const VideoBanner = styled.div`
  width: 99%;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 1rem;
  box-shadow: ${boxShadow1};
  border-radius: 0.75rem;

  & > video {
    max-height: 70dvh !important;
    width: 100%;
    border-radius: 0.5rem;
    //flex: 1;
  }
`;

interface IVideoViewProps {
  data: {
    document: { url: string; [key: string]: any };
    name: string;
    description: string;
    [key: string]: any;
  };
}

const VideoView: FC<IVideoViewProps> = ({ data }) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  return (
    <>
      <VideoBanner>
        <video
          height="360"
          width="640"
          ref={videoRef}
          src={data.document.url}
          controls
        />
        {/*<VideoButtonGroup>
                      {isPlayingVideo ? (
                        <IconHolder>
                          <LocalIcon
                            iconName={'pause-circle.svg'}
                            onClick={togglePlayPauseVideo}
                            color={black}
                            isLink={true}
                          />
                        </IconHolder>
                      ) : (
                        <IconHolder>
                          <LocalIcon
                            iconName={'play-circle.svg'}
                            onClick={togglePlayPauseVideo}
                            color={black}
                            isLink={true}
                          />
                        </IconHolder>
                      )}
                      <IconHolder>
                        <LocalIcon
                          iconName={'stop-circle.svg'}
                          onClick={stopVideo}
                          color={black}
                          isLink={true}
                        />
                      </IconHolder>
                    </VideoButtonGroup>*/}
        <Caption>{data.name}</Caption>
      </VideoBanner>
      {data.description && (
        <Content>
          <PageCKEditor
            item={data}
            editing={false}
            updateContent={() => {
              /*console.log();*/
            }}
            saving={false}
            content={data.description}
          />
        </Content>
      )}
    </>
  );
};

export default VideoView;
